import {PropsWithChildren} from "react";
import {useLocation, useNavigate} from "react-router";

import Button from "@/components/button/Button.tsx";
import {ButtonSize, ButtonTypography, ButtonVariant} from "@/components/button/Button.types.ts";
import {IncidentType} from "@/lib/types/statuspages.ts";

export interface IncidentCreateActionProps extends PropsWithChildren {
  incidentType?: IncidentType;
  statusPageId?: number;
  variant?: ButtonVariant;
  size?: ButtonSize;
  typography?: ButtonTypography;
  className?: string;
  disableStatusPageSelect?: boolean;
}

export const IncidentCreateAction = ({
  statusPageId,
  incidentType = IncidentType.INCIDENT,
  children,
  disableStatusPageSelect,
  ...rest
}: IncidentCreateActionProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = () => {
    const params = new URLSearchParams();
    if (statusPageId) {
      params.set("statusPageId", statusPageId.toString());
    }
    if (incidentType) {
      params.set("incidentType", incidentType);
    }
    if (disableStatusPageSelect) {
      params.set("disableStatusPageSelect", "true");
    }
    params.set("redirectTo", location.pathname + location.search);

    navigate(`/incidents/create?${params.toString()}`);
  };

  return (
    <Button {...rest} onClick={handleClick}>
      {children}
    </Button>
  );
};
